// import React, { useState } from "react";
// import {
//   Navbar,
//   Nav,
//   Container,
//   Button,
//   Collapse,
//   Offcanvas,
// } from "react-bootstrap";
// import {
//   People,
//   PersonPlus,
//   List,
//   Book,
//   ClipboardCheck,
//   CalendarCheck,
//   Building,
//   ChevronDown,
//   ChevronUp,
//   BoxArrowRight,
// } from "react-bootstrap-icons";
// import { Link } from "react-router-dom";

// export default function Sidenavbar() {
//   const [openDropdown, setOpenDropdown] = useState("");
//   const [show, setShow] = useState(false);

//   const toggleDropdown = (dropdown) => {
//     setOpenDropdown(openDropdown === dropdown ? "" : dropdown);
//   };

//   return (
//     <>
//       {/* Offcanvas for Mobile View */}
//       <Navbar expand="lg" className="d-lg-none bg-primary shadow-sm fixed-top">
//         <Container>
//           <Navbar.Brand className="fw-bold text-white ms-auto">
//             🎓 Student Portal
//           </Navbar.Brand>
//           <Navbar.Toggle
//             onClick={() => setShow(true)}
//             className="border-0 text-white position-fixed"
//             style={{ top: "10px", left: "10px", zIndex: "1050", boxShadow: "none" }}
//           />
//           <Offcanvas show={show} onHide={() => setShow(false)} placement="start" className="bg-light">
//             <Offcanvas.Header closeButton>
//               <Offcanvas.Title className="fw-bold text-primary">
//                 🎓 Student Portal
//               </Offcanvas.Title>
//             </Offcanvas.Header>
//             <Offcanvas.Body className="d-flex flex-column justify-content-between" style={{ minHeight: "100vh" }}>
//               <Nav className="flex-column w-100">
//                 {/* Students Dropdown */}
//                 <Button variant="light" className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2" onClick={() => toggleDropdown("students")}>
//                   <span>
//                     <People size={20} className="me-2" /> Students
//                   </span>
//                   {openDropdown === "students" ? <ChevronUp /> : <ChevronDown />}
//                 </Button>
//                 <Collapse in={openDropdown === "students"}>
//                   <div>
//                     <Link to="/AddStudent" className="nav-link text-dark ps-4">
//                       <PersonPlus size={18} className="me-2" /> Add Student
//                     </Link>
//                     <Link to="/StudentList" className="nav-link text-dark ps-4">
//                       <List size={18} className="me-2" /> Student List
//                     </Link>
//                   </div>
//                 </Collapse>
//               </Nav>
//               <div className="mt-auto p-3">
//                 <Button variant="danger" className="w-100">
//                   <BoxArrowRight size={20} className="me-2" /> Logout
//                 </Button>
//               </div>
//             </Offcanvas.Body>
//           </Offcanvas>
//         </Container>
//       </Navbar>

//       {/* Sidebar for Desktop View */}
//       <div className="d-none d-lg-flex" style={{ height: "auto", minHeight: "100vh" }}>
//         <Navbar bg="white" variant="light" expand="lg" className="flex-column p-4 shadow" style={{ width: "270px", minHeight: "100vh", borderRadius: "20px" }}>
//           <Container className="d-flex flex-column h-100">
//             <h5 className="fw-bold mb-4 text-primary">🎓 Student Portal</h5>
//             <Nav className="flex-column w-100">
//               <Button variant="light" className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2" onClick={() => toggleDropdown("students")}>
//                 <span>
//                   <People size={20} className="me-2" /> Students
//                 </span>
//                 {openDropdown === "students" ? <ChevronUp /> : <ChevronDown />}
//               </Button>
//               <Collapse in={openDropdown === "students"}>
//                 <div>
//                   <Link to="/AddStudent" className="nav-link text-dark ps-4">
//                     <PersonPlus size={18} className="me-2" /> Add Student
//                   </Link>
//                   <Link to="/StudentList" className="nav-link text-dark ps-4">
//                     <List size={18} className="me-2" /> Student List
//                   </Link>
//                 </div>
//               </Collapse>
//             </Nav>
//             <div className="mt-auto w-100 p-3">
//               <Button variant="danger" className="w-100">
//                 <BoxArrowRight size={20} className="me-2" /> Logout
//               </Button>
//             </div>
//           </Container>
//         </Navbar>
//       </div>
//     </>
//   );
// }



// import React, { useState } from "react";
// import {
//   Navbar,
//   Nav,
//   Container,
//   Button,
//   Collapse,
//   Offcanvas,
// } from "react-bootstrap";
// import {
//   People,
//   PersonPlus,
//   List,
//   Book,
//   ClipboardCheck,
//   CalendarCheck,
//   Building,
//   ChevronDown,
//   ChevronUp,
//   BoxArrowRight,

// } from "react-bootstrap-icons";
// import { Link } from "react-router-dom";

// export default function Sidenavbar() {
//   const [openDropdown, setOpenDropdown] = useState("");
//   const [show, setShow] = useState(false);

//   const toggleDropdown = (dropdown) => {
//     setOpenDropdown(openDropdown === dropdown ? "" : dropdown);
//   };

//   return (
//     <>
//       {/* Offcanvas for Mobile View */}
//       <Navbar expand="lg" className="d-lg-none bg-primary shadow-sm fixed-top">
//         <Container>
//           <Navbar.Brand className="fw-bold text-white ms-auto">
//             🎓 Student Portal
//           </Navbar.Brand>

//           <Navbar.Toggle
//             onClick={() => setShow(true)}
//             className="border-0 text-white position-fixed"
//             style={{
//               top: "10px",
//               left: "10px",
//               zIndex: "1050",
//               boxShadow: "none",
//               width: show ? "200px" : "auto", // Width changes when Offcanvas is open
//             }}
//           />

//           <Offcanvas
//              show={show} onHide={() => setShow(false)} placement="start" className="bg-light" backdrop={false}
//           >
//             <Offcanvas.Header closeButton>
//               <Offcanvas.Title className="fw-bold  text-primary">
//                 🎓 Student Portal
//               </Offcanvas.Title>
//             </Offcanvas.Header>
//             <Offcanvas.Body>
//               <Nav className="flex-column w-100">
//                 {/* Students Dropdown */}
//                 <Button
//                   variant="light"
//                   className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                   onClick={() => toggleDropdown("students")}
//                 >
//                   <span>
//                     <People size={20} className="me-2" /> Students
//                   </span>
//                   {openDropdown === "students" ? (
//                     <ChevronUp />
//                   ) : (
//                     <ChevronDown />
//                   )}
//                 </Button>
//                 <Collapse in={openDropdown === "students"}>
//                   <div>
//                     <Link to="/AddStudent" className="nav-link text-dark ps-4">
//                       <PersonPlus size={18} className="me-2" /> Add Student
//                     </Link>
//                     <Link to="/StudentList" className="nav-link text-dark ps-4">
//                       <List size={18} className="me-2" /> Student List
//                     </Link>
//                   </div>
//                 </Collapse>

//                 {/* Courses Dropdown */}
//                 <Button
//                   variant="light"
//                   className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                   onClick={() => toggleDropdown("courses")}
//                 >
//                   <span>
//                     <Book size={20} className="me-2" /> Courses
//                   </span>
//                   {openDropdown === "courses" ? <ChevronUp /> : <ChevronDown />}
//                 </Button>
//                 <Collapse in={openDropdown === "courses"}>
//                   <div>
//                     <Link to="/AddCourse" className="nav-link text-dark ps-4">
//                       <PersonPlus size={18} className="me-2" /> Add Course
//                     </Link>
//                     <Link to="/CourseList" className="nav-link text-dark ps-4">
//                       <List size={18} className="me-2" /> Course List
//                     </Link>
//                   </div>
//                 </Collapse>

//                 {/* Classes Dropdown */}
//                 <Button
//                   variant="light"
//                   className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                   onClick={() => toggleDropdown("classes")}
//                 >
//                   <span>
//                     <Building size={20} className="me-2" /> Classes
//                   </span>
//                   {openDropdown === "classes" ? <ChevronUp /> : <ChevronDown />}
//                 </Button>
//                 <Collapse in={openDropdown === "classes"}>
//                   <div>
//                     <Link to="/AddClass" className="nav-link text-dark ps-4">
//                       <PersonPlus size={18} className="me-2" /> Add Class
//                     </Link>
//                     <Link to="/ClassList" className="nav-link text-dark ps-4">
//                       <List size={18} className="me-2" /> Class List
//                     </Link>
//                   </div>
//                 </Collapse>

//                 {/* Attendance Dropdown */}
//                 <Button
//                   variant="light"
//                   className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                   onClick={() => toggleDropdown("attendance")}
//                 >
//                   <span>
//                     <ClipboardCheck size={20} className="me-2" /> Attendance
//                   </span>
//                   {openDropdown === "attendance" ? (
//                     <ChevronUp />
//                   ) : (
//                     <ChevronDown />
//                   )}
//                 </Button>
//                 <Collapse in={openDropdown === "attendance"}>
//                   <div>
//                     <Link
//                       to="/TakeAttendance"
//                       className="nav-link text-dark ps-4"
//                     >
//                       <CalendarCheck size={18} className="me-2" /> Take
//                       Attendance
//                     </Link>
//                   </div>
//                 </Collapse>
//               </Nav>

//               <div className="mt-auto p-3">
//                 <Button variant="danger" className="w-100">
//                   <BoxArrowRight size={20} className="me-2" /> Logout
//                 </Button>
//               </div>


//             </Offcanvas.Body>
//           </Offcanvas>
//         </Container>
//       </Navbar>

//       {/* Sidebar for Desktop View */}
//       <div
//         className="d-none d-lg-flex"
//         style={{ height: "auto", minHeight: "100vh" }}
//       >
//         <Navbar
//           bg="white"
//           variant="light"
//           expand="lg"
//           className="flex-column p-4 shadow"
//           style={{ width: "270px", height: "auto", borderRadius: "20px" }}
//         >
//           <Container className="d-flex flex-column align-items-end">
//             <h5 className="fw-bold mb-4 text-primary float-end">
//               🎓 Student Portal
//             </h5>
//             <Nav className="flex-column w-100">
//               {/* Students Dropdown */}
//               <Button
//                 variant="light"
//                 className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                 onClick={() => toggleDropdown("students")}
//               >
//                 <span>
//                   <People size={20} className="me-2" /> Students
//                 </span>
//                 {openDropdown === "students" ? <ChevronUp /> : <ChevronDown />}
//               </Button>
//               <Collapse in={openDropdown === "students"}>
//                 <div>
//                   <Link to="/AddStudent" className="nav-link text-dark ps-4">
//                     <PersonPlus size={18} className="me-2" /> Add Student
//                   </Link>
//                   <Link to="/StudentList" className="nav-link text-dark ps-4">
//                     <List size={18} className="me-2" /> Student List
//                   </Link>
//                 </div>
//               </Collapse>

//               {/* Courses Dropdown */}
//               <Button
//                 variant="light"
//                 className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                 onClick={() => toggleDropdown("courses")}
//               >
//                 <span>
//                   <Book size={20} className="me-2" /> Courses
//                 </span>
//                 {openDropdown === "courses" ? <ChevronUp /> : <ChevronDown />}
//               </Button>
//               <Collapse in={openDropdown === "courses"}>
//                 <div>
//                   <Link to="/AddCourse" className="nav-link text-dark ps-4">
//                     <PersonPlus size={18} className="me-2" /> Add Course
//                   </Link>
//                   <Link to="/CourseList" className="nav-link text-dark ps-4">
//                     <List size={18} className="me-2" /> Course List
//                   </Link>
//                 </div>
//               </Collapse>

//               {/* Classes Dropdown */}
//               <Button
//                 variant="light"
//                 className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                 onClick={() => toggleDropdown("classes")}
//               >
//                 <span>
//                   <Building size={20} className="me-2" /> Classes
//                 </span>
//                 {openDropdown === "classes" ? <ChevronUp /> : <ChevronDown />}
//               </Button>
//               <Collapse in={openDropdown === "classes"}>
//                 <div>
//                   <Link to="/AddClass" className="nav-link text-dark ps-4">
//                     <PersonPlus size={18} className="me-2" /> Add Class
//                   </Link>
//                   <Link to="/ClassList" className="nav-link text-dark ps-4">
//                     <List size={18} className="me-2" /> Class List
//                   </Link>
//                 </div>
//               </Collapse>

//               {/* Attendance Dropdown */}
//               <Button
//                 variant="light"
//                 className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
//                 onClick={() => toggleDropdown("attendance")}
//               >
//                 <span>
//                   <ClipboardCheck size={20} className="me-2" /> Attendance
//                 </span>
//                 {openDropdown === "attendance" ? (
//                   <ChevronUp />
//                 ) : (
//                   <ChevronDown />
//                 )}
//               </Button>
//               <Collapse in={openDropdown === "attendance"}>
//                 <div>
//                   <Link
//                     to="/TakeAttendance"
//                     className="nav-link text-dark ps-4"
//                   >
//                     <CalendarCheck size={18} className="me-2" /> Take Attendance
//                   </Link>
//                 </div>
//               </Collapse>
//             </Nav>

//             <div className="mt-auto w-100 p-3">
//               <Button variant="danger" className="w-100">
//                 <BoxArrowRight size={20} className="me-2" /> Logout
//               </Button>
//             </div>
//           </Container>
//         </Navbar>
//       </div>
//     </>
//   );
// }




import React, { useState } from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Collapse,
  Offcanvas,
} from "react-bootstrap";
import {
  People,
  PersonPlus,
  List,
  Book,
  ClipboardCheck,
  CalendarCheck,
  Building,
  ChevronDown,
  ChevronUp,
  BoxArrowRight,
  CurrencyDollar
} from "react-bootstrap-icons";
import { Link } from "react-router-dom";

export default function Sidenavbar() {
  const [openDropdown, setOpenDropdown] = useState("");
  const [show, setShow] = useState(false);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? "" : dropdown);
  };

  return (
    <>
      {/* Sidebar for Desktop View */}
      <div className="d-none d-lg-flex" style={{ height: "auto", minHeight: "100vh" }}>
        <Navbar
          bg="white"
         



          variant="light"
          expand="lg"
          className="flex-column p-4 shadow w-auto"
          style={{
            width: "270px",
            minHeight: "100vh",
            overflowY: "auto",
            borderRadius: "20px",
            position: "relative", // Ensures button stays at the bottom
          }}
        >
          <Container className="d-flex flex-column align-items-end">
            <h5 className="fw-bold mb-4 text-primary float-end">🎓 Student Portal</h5>
            <Nav className="flex-column w-100">
              {/* Fees Dropdown */}
              <Button
                variant="light"
                className="text-dark w-100 text-start d-flex justify-content-between align-items-center py-2"
                onClick={() => toggleDropdown("fees")}
              >
                <span>
                  <CurrencyDollar size={20} className="me-2" /> Fees
                </span>
                {openDropdown === "fees" ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === "fees"}>
                <div>
                  <Link to="/AddFees" className="nav-link text-dark ps-4">
                    <PersonPlus size={18} className="me-2" /> Add Fees
                  </Link>
                  <Link to="/FeesList" className="nav-link text-dark ps-4">
                    <List size={18} className="me-2" /> Fees List
                  </Link>
                </div>
              </Collapse>
            </Nav>
          </Container>
        </Navbar>
      </div>
    </>
  );
}
